// extracted by mini-css-extract-plugin
export default {"iconWrap":"PinnedIcon_iconWrap__LudT9","icon":"PinnedIcon_icon__jE6gM","unClickable":"PinnedIcon_unClickable__W1jnG"};